<template lang="pug">
  b-modal#edit-phones(size="lg" hide-header hide-footer)
    .phones
      .exists-phones
        ul
          li(v-for="(phone, idx) in existsPhones")
            phone-element(
              :phone="phone"
              :index="idx"
              :existsPhone="true"
              :allPhones="allPhones"
              @switchExistsPhoneState="switchExistsPhoneState"
              @deleteNewPhone="deleteNewPhone"
            )
      .new-phones
        ul
          li(v-for="(phone, idx) in newPhones")
            phone-element(
              ref="newPhone"
              :phone="phone"
              :index="idx"
              :existsPhone="false"
              :allPhones="allPhones"
              @switchExistsPhoneState="switchExistsPhoneState"
              @deleteNewPhone="deleteNewPhone"
            )

      .add-new-phone
        button(@click="addPhone") {{ $t('edit_profile.add_number') }}

      .save-phone-actions
        button.save(@click="save" :disabled="disableSave") Save
        button.cancel(@click="cancel") Cancel
</template>

<script>
  import { filter, uniqBy, reject, some, isEmpty } from 'lodash'
  import PhoneElement from '@/pages/Profile/Edit/shared/phone'

  export default {
    components: {
      PhoneElement
    },

    props: {
      phones: {
        type: Array,
        default() {
          return []
        }
      }
    },

    data() {
      return {
        newPhones: [],
        existsPhones: [],
      }
    },

    computed: {
      disableSave() {
        return this.isEmptyNumberField || this.isAnyErrors || this.isDuplicatedPhones()
      },

      isEmptyNumberField() {
        return some(this.newPhones, ({ number }) => number == '')
      },

      isAnyErrors() {
        return some(this.$refs.newPhone, ({ v_errors }) => v_errors.any())
      },

      newEmptyPhone() {
        return this.newPhones.includes({ number: '', extension: '' })
      },

      allPhones() {
        return this.newPhones.concat(this.existsPhones).map(({ number, extension }) => ({ number, extension }))
      }
    },

    mounted() {
      this.fillNewPhones()
      this.fillExistsPhones()
    },

    methods: {
      fillNewPhones() {
        this.newPhones = reject(this.phones, 'id')
      },

      fillExistsPhones() {
        this.existsPhones = filter(this.phones, 'id')
      },

      deleteNewPhone({ number, extension }) {
        this.newPhones =
          reject(this.newPhones, phone => phone.number == number && phone.extension == extension)
      },

      switchExistsPhoneState({ value, phone }) {
        this.changeValue(value, phone)
      },

      changeValue(value, { id }) {
        const phones = this.existsPhones.map((phone) => {
          if (phone.id == id) {
            return { ...phone, _destroy: value }
          } else {
            return phone
          }
        })
        this.existsPhones = phones
      },

      addPhone() {
        const phone = { number: '', extension: '' }
        const phones = this.newPhones.concat(phone)
        this.newPhones = uniqBy(phones, ({ number, extension }) => `${number}${extension}`)
      },

      save() {
        const phones = this.completedPhones(this.newPhones.concat(this.existsPhones))
        this.$bvModal.hide('edit-phones')
        this.$emit('savePhones', phones)
      },

      cancel() {
        this.$bvModal.hide('edit-phones')
        this.$emit('cancelSavePhones')
      },

      completedPhones(phones) {
        return reject(phones, ({ number }) => isEmpty(number))
      },

      isDuplicatedPhones() {
        return some(this.$refs.newPhone, ({ isDuplicatedPhones }) => isDuplicatedPhones)
      },
    }
  }
</script>

<style lang="scss" scoped>
  .phones {
    margin: 15px 0 0 20px;
    max-height: 70vh;
    overflow: scroll;

    div {
      margin: 5px;
    }

    button {
      background-color: transparent;
      border: 0;
      color: #008bd0;
      font-size: 14px;
      font-weight: 500;
      letter-spacing: 0;
    }

    ul {
      padding: 0;

      li {
        display: flex;
        margin: 5px 0;
      }
    }

    .save-phone-actions {
      margin-top: 30px;

      button {
        margin-right: 10px;
      }

      .cancel {
        background: transparent;
        border: 1px solid rgba(0, 156, 234, 0.3);
        border-radius: 4px;
        color: #009cea;
        margin-right: 20px;
        padding: 5px 20px;
      }

      .save {
        background-image: linear-gradient(90deg, rgba(24, 172, 235, 0.98) 0%, #18a4eb 100%);
        border-color: transparent !important;
        border-radius: 4px;
        color: #fff;
        padding: 5px 20px;
      }
    }
  }
</style>
